<div class="title">
  ინფორმაცია მოგზაურზე
</div>
<ng-container *ngIf="user.PassengerInfo; index as i">
  <div class="child d-flex" *ngFor="let u of user.PassengerInfo; index as i">
    <span>
      {{u.name}}
      {{u.surname}}
    </span>
    <div class="del" (click)="del(i)">
      <i class="fas fa-trash"></i>
    </div>
  </div>
</ng-container>
<p class="none"  *ngIf="!user.PassengerInfo?.length">დაზღვეული მოგზაური არ მოიძებნა</p>
<div class="row mt-5 text-center-xs" *ngIf="user.PassengerInfo?.length < 5">
  <div class="col-12">
    <a target="_blank" (click)="addChild()">
      <i class="fas fa-plus-circle me-2"></i>
      მოგზაურის დამატება
    </a>
  </div>
</div>
<div class="sheet-buttons g g--spaceAround g--wrap g--nowrap@s g--alignEnd mt-5 mb-5">
  <app-prev-btn *ngIf="showBack" (click)="prev()"></app-prev-btn>
  <app-next-btn (click)="onSubmit()"></app-next-btn>
</div>
